import { render } from "./UploadRecordEdit.vue?vue&type=template&id=c4932ef4"
import script from "./UploadRecordEdit.vue?vue&type=script&lang=js"
export * from "./UploadRecordEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__